import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ObrasService } from '../../services/obras.service';
import { ProveedoresService } from '../../services/proveedores.service';
import { ReporteCobranzaService } from '../../services/reporte-cobranza.service';
import { MovimientosObraService } from '../../services/movimientos-obra.service';
import { HelpersService } from '../../services/tools/helpers.service';
import { ReportesService } from '../../services/reportes.service';
import { AutenticacionService, ModulosARK, TipoPermiso } from './../../services/autenticacion.service';

declare var moment;

@Component({
  selector: 'app-reporte-cobranza',
  templateUrl: './reporte-cobranza.component.html',
  styleUrls: ['./reporte-cobranza.component.scss']
})

export class ReporteCobranzaComponent implements OnInit {
    //Selector reporte
    public reportes_lista: any[] = [];
    public reporte_actual: any = {};

    //filters
    public obras: any [] = [];
    public obra: any = {idObras:null};

    public proveedor: any = {idProveedores:null};
    public proveedores: any [] = [];
    
    public fechaInicio: any;
    public fechaTermino: any;
    public fecha_actual: any;

    //Selector de periodo (mes/anio)
    public mesSel: number;
    public anioSel: number;
    public periodoTexto: string = '';
    public meses = [
        {n:1,nombre:'Enero'},{n:2,nombre:'Febrero'},{n:3,nombre:'Marzo'},{n:4,nombre:'Abril'},
        {n:5,nombre:'Mayo'},{n:6,nombre:'Junio'},{n:7,nombre:'Julio'},{n:8,nombre:'Agosto'},
        {n:9,nombre:'Septiembre'},{n:10,nombre:'Octubre'},{n:11,nombre:'Noviembre'},{n:12,nombre:'Diciembre'}
    ];
    public anios: number[] = [];
    
    //helpers
    public loading: boolean = true; //regresar
    public loading_obras: boolean = false;
    public loading_proveedores: boolean = false;
    public exportingCSV:boolean = false;
    public first_load:boolean = true;

    public reporte: any [] = [];
    errors:any = {};

    //Detalle de la deuda (modal al hacer clic en un renglon)
    @ViewChild('detalleModal') private detalleModal: TemplateRef<any>;
    public detalle: any = null;
    public loadingDetalle: boolean = false;

    //Filtros de pantalla. El API ya devuelve el reporte completo, asi que estos solo
    //acotan lo que se ve; los totales se recalculan con las filas visibles para que
    //siempre cuadren con lo que se esta mostrando.
    public soloConAdeudo: boolean = false;
    public soloVencidos: boolean = false;
    public soloFacturadoMano: boolean = false;
    public busqueda: string = '';

    //Lista completa de miembros. El selector se acota a los que aparecen en el inmueble
    //elegido, pero hay que conservar la lista entera para poder restaurarla.
    public proveedoresTodos: any[] = [];
    private detalleModalRef: any = null;

    constructor(private router: Router,
        private modalService: NgbModal,
        private movimientosObraService: MovimientosObraService,
        private obrasService: ObrasService,
        private proveedoresService: ProveedoresService,
        private reporteCobranzaService: ReporteCobranzaService,
        private helperService: HelpersService,
        private reportesService: ReportesService,
        private authService: AutenticacionService) {

    }

    ngOnInit() {
        let reportes_lista = this.reportesService.getListaReportes();
        console.log("reportes_lista:",JSON.stringify(reportes_lista));
        for (let i = 0; i < reportes_lista.length; i++) {  
          if(reportes_lista[i]["id"] == 1 && this.authService.tienenPermisos(ModulosARK.ReportePorInversionista, TipoPermiso.Lectura)){
            this.reportes_lista.push(reportes_lista[i]);
          }
          if(reportes_lista[i]["id"] == 2 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeObra, TipoPermiso.Lectura)){
            this.reportes_lista.push(reportes_lista[i]);
          }
          if(reportes_lista[i]["id"] == 3 && this.authService.tienenPermisos(ModulosARK.ReportePorObra, TipoPermiso.Lectura)){
            this.reportes_lista.push(reportes_lista[i]);
          }
          if(reportes_lista[i]["id"] == 4 && this.authService.tienenPermisos(ModulosARK.ReporteBalanceKr, TipoPermiso.Lectura)){
            this.reportes_lista.push(reportes_lista[i]);
          }
          if(reportes_lista[i]["id"] == 5 && this.authService.tienenPermisos(ModulosARK.ReportePuntoDeEquilibrio, TipoPermiso.Lectura)){
            this.reportes_lista.push(reportes_lista[i]);
          }
          if(reportes_lista[i]["id"] == 6 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeDiferencia, TipoPermiso.Lectura)){
            this.reportes_lista.push(reportes_lista[i]);
          }
          if(reportes_lista[i]["id"] == 7 && this.authService.tienenPermisos(ModulosARK.ReporteSaldos, TipoPermiso.Lectura)){
            this.reportes_lista.push(reportes_lista[i]);
          }
          if(reportes_lista[i]["id"] == 8 && this.authService.tienenPermisos(ModulosARK.ReporteDepositoGarantia, TipoPermiso.Lectura)){
            this.reportes_lista.push(reportes_lista[i]);
          }
          if(reportes_lista[i]["id"] == 9 && this.authService.tienenPermisos(ModulosARK.ReporteCobranza, TipoPermiso.Lectura)){
            this.reportes_lista.push(reportes_lista[i]);
            this.reporte_actual = reportes_lista[i]; //reporte de cobranza
          }
        }
        this.getFechaActual();
        this.loadObras();
    }

    canExport() {
        return this.movimientosObraService.canExport();
    }

    exportCSV() {
        /*
        this.exportingCSV = true;
        console.log("this.obra.idObras: ",this.obra.idObras);
        this.cuentasPorCobrarService.exportCSV(this.fechaTermino,this.incluir_cobradas,
            this.incluir_canceladas, this.obra.idObras, this.proveedor.idProveedores, )
          .subscribe((response) => {
            this.exportingCSV = false;
          }, (error) => {
            // se resuelven los errores 403 y 500
            this.helperService.httpGlobalError(error);
        });
        */
    }

    getFechaActual() {
        this.movimientosObraService.getFechaActual()
            .subscribe((response) => {
                const content = response.json().content;
                var fecha_actual = moment(content.fecha);
                this.fecha_actual = fecha_actual.format("YYYY-MM-DD");
                //Selector de periodo: por defecto el mes actual
                this.anioSel = fecha_actual.year();
                this.mesSel = fecha_actual.month() + 1;
                this.anios = [];
                for (let a = this.anioSel - 3; a <= this.anioSel + 1; a++) { this.anios.push(a); }
                this.aplicarPeriodo();
            }, (error) => {
                // se revisan errores 403 - 500
                this.helperService.httpGlobalError(error);

                if (error == 400) {
                console.log('getFechasActual - error 400 ' , error);
                }
            });
    }

    //Aplica el periodo seleccionado: del dia 1 al ultimo dia del mes (o a hoy si es el mes actual)
    public aplicarPeriodo() {
        if (!this.mesSel || !this.anioSel) { return; }
        const primer = moment([this.anioSel, this.mesSel - 1, 1]);
        const hoy = moment(this.fecha_actual);
        const esMesActual = (this.anioSel === hoy.year() && this.mesSel === (hoy.month() + 1));
        const ultimo = esMesActual ? hoy.clone() : primer.clone().endOf('month');
        this.fechaInicio = primer.format("YYYY-MM-DD");
        this.fechaTermino = ultimo.format("YYYY-MM-DD");
        this.periodoTexto = '01 al ' + ultimo.format('DD') + ' de ' + this.meses[this.mesSel - 1].nombre + ' de ' + this.anioSel;
        this.loadReporte();
    }

    loadObras(){
        this.loading_obras = true;
        this.obrasService.getObratoSelect()
        .subscribe((response) => {
            this.obras = response.json().content;
            this.loadProveedores();
            this.loading_obras = false;
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading_obras = false;
        });
    }

    loadProveedores(){
        this.loading_proveedores = true;
        this.proveedoresService.getProveedorestoSelect()
        .subscribe(response => {
            let content = response.json().content;
            this.proveedoresTodos = content.proveedores;
            this.proveedores = content.proveedores;
            this.loading_proveedores = false;
            this.first_load = false;
            this.loadReporte();
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading_proveedores = false;
        });
    }

    private loadReporte(){
        if(this.first_load){
            return;
        }
        console.log("Obra: ",this.obra);
        console.log("proveedor: ",this.proveedor);
        if (this.fechaInicio && this.fechaTermino && !this.first_load){
            this.loading = true;
            this.reporteCobranzaService.getReporteCobranza(this.obra.idObras,this.proveedor.idProveedores,this.fechaInicio,this.fechaTermino)
            .subscribe(response => {
                let content = response.json().content;
                for (let i = 0; i < content.length; i++) {
                    content[i]["totales"]["adeudo_actual"]["importe_val"] = parseFloat(content[i]["totales"]["adeudo_actual"]["importe"].replace(/,/g, ""));
                    content[i]["totales"]["adeudo_actual"]["iva_val"] = parseFloat(content[i]["totales"]["adeudo_actual"]["iva"].replace(/,/g, ""));
                    content[i]["totales"]["adeudo_anterior"]["importe_val"] = parseFloat(content[i]["totales"]["adeudo_anterior"]["importe"].replace(/,/g, ""));
                    content[i]["totales"]["adeudo_anterior"]["iva_val"] = parseFloat(content[i]["totales"]["adeudo_anterior"]["iva"].replace(/,/g, ""));
                    content[i]["totales"]["cobranza"]["importe_val"] = parseFloat(content[i]["totales"]["cobranza"]["importe"].replace(/,/g, ""));
                    content[i]["totales"]["cobranza"]["iva_val"] = parseFloat(content[i]["totales"]["cobranza"]["iva"].replace(/,/g, ""));
                    content[i]["totales"]["contratado"]["importe_val"] = parseFloat(content[i]["totales"]["contratado"]["importe"].replace(/,/g, ""));
                    content[i]["totales"]["contratado"]["iva_val"] = parseFloat(content[i]["totales"]["contratado"]["iva"].replace(/,/g, ""));
                    for (let j = 0; j < content[i]["datos"].length; j++) {
                        //console.log("Adeudo anteior: ",content[i]["datos"][j]);//["adeudo_anterior"]["importe"]);
                        content[i]["datos"][j]["adeudo_anterior"]["importe_val"] = parseFloat(content[i]["datos"][j]["adeudo_anterior"]["importe"].replace(/,/g, ""));
                        //content[i]["datos"][j]["adeudo_anterior"]["iva_val"] = parseFloat(content[i]["datos"][j]["adeudo_anterior"]["iva"].replace(/,/g, ""));
                        content[i]["datos"][j]["cobranza_mes"]["importe_val"] = parseFloat(content[i]["datos"][j]["cobranza_mes"]["importe"].replace(/,/g, ""));
                        //content[i]["datos"][j]["cobranza_mes"]["iva_val"] = parseFloat(content[i]["datos"][j]["cobranza_mes"]["iva"].replace(/,/g, ""));
                    }
                }
                this.reporte = content;
                this.aplicarFiltros();
                this.acotarMiembros();
                this.first_load = false;
                this.loading = false;
            },error=>{
                alert("ERROR: "+JSON.stringify(error));
                this.loading = false;
            });
        }
    }

    public filtrarReporte(filtro,$event){
        if(filtro=='inmueble'){
            this.obra=$event;
            //Al cambiar de inmueble se devuelve la lista completa de miembros: la que
            //estaba era del inmueble anterior. Se volvera a acotar al cargar el reporte.
            this.proveedores = this.proveedoresTodos;
        }else if(filtro=='miembro'){
            this.proveedor=$event;
        }else if(filtro=="fechaTermino"){
            this.fechaTermino=$event;
        }else if(filtro=="fechaInicio"){
            this.fechaInicio=$event;
        }
        this.loadReporte();
    }

    //Selector de reporte
    /**
     * Los importes viajan como texto ya formateado ("1,234.56"), asi que hay que
     * quitarles la coma de miles antes de poder sumarlos.
     */
    private aNumero(valor): number {
        if (valor === null || valor === undefined) { return 0; }
        const numero = parseFloat(String(valor).replace(/,/g, ''));
        return isNaN(numero) ? 0 : numero;
    }

    private tieneAdeudo(c): boolean {
        if (!c || !c.adeudo_actual) { return false; }
        return (this.aNumero(c.adeudo_actual.importe) + this.aNumero(c.adeudo_actual.iva)) > 0.005;
    }

    /**
     * Recalcula, para cada inmueble del reporte, que filas se ven y cuanto suman.
     * Se guarda en el propio objeto (datosVisibles/totalesVisibles) en vez de
     * llamar metodos desde el HTML, que se reevaluarian en cada ciclo de Angular.
     */
    //Etiqueta del grupo cuando el renglon no tiene edificio (cobros facturados a mano)
    public SIN_EDIFICIO = 'Facturado a mano';

    private edificioDeFila(c) {
        if (c && c.edificio) { return c.edificio; }
        return this.SIN_EDIFICIO;
    }

    private sumarColumnas(filas, columnas) {
        const totales: any = {};
        for (const nombreTotal of Object.keys(columnas)) {
            const campoFila = columnas[nombreTotal];
            let importe = 0;
            let iva = 0;
            for (const c of (filas || [])) {
                if (c && c[campoFila]) {
                    importe += this.aNumero(c[campoFila].importe);
                    iva += this.aNumero(c[campoFila].iva);
                }
            }
            totales[nombreTotal] = {
                importe: importe.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                iva: iva.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                //La fila de totales pinta en rojo los negativos usando estos campos;
                //sin ellos la comparacion daria falso y todo saldria en rojo.
                importe_val: importe,
                iva_val: iva
            };
        }
        return totales;
    }

    public aplicarFiltros() {
        const texto = (this.busqueda || '').trim().toLowerCase();
        //Nombre del total <- nombre del campo en la fila (no siempre coinciden)
        const columnas: any = {
            'contratado': 'contratado',
            'contratado_renta': 'contratado_renta',
            'contratado_mantenimiento': 'contratado_mantenimiento',
            'adeudo_anterior': 'adeudo_anterior',
            'cobranza': 'cobranza_mes',
            'adeudo_actual': 'adeudo_actual'
        };

        for (const rep of (this.reporte || [])) {
            const filas = (rep && rep.datos) ? rep.datos : [];

            rep.datosVisibles = filas.filter((c) => {
                if (this.soloConAdeudo && !this.tieneAdeudo(c)) { return false; }
                if (this.soloVencidos && !c.contrato_vencido) { return false; }
                if (this.soloFacturadoMano && !c.facturado_directo) { return false; }
                if (texto) {
                    const donde = [
                        c.local, c.inquilino, c.inquilino_contrato, c.edificio,
                        (c.conceptos || []).join(' ')
                    ].join(' ').toLowerCase();
                    if (donde.indexOf(texto) === -1) { return false; }
                }
                return true;
            });

            rep.totalesVisibles = this.sumarColumnas(rep.datosVisibles, columnas);

            // Los renglones se agrupan por edificio con su subtotal: OP PREMIER es el
            // operador y factura en varios hubs a la vez (SLP, Tehuantepec, Insurgentes...),
            // asi que su tarjeta mezclaba todos los inmuebles en una sola lista.
            const grupos = [];
            const porEdificio = {};
            for (const c of rep.datosVisibles) {
                const edificio = this.edificioDeFila(c);
                if (porEdificio[edificio] === undefined) {
                    porEdificio[edificio] = grupos.length;
                    grupos.push({ edificio: edificio, filas: [] });
                }
                grupos[porEdificio[edificio]].filas.push(c);
            }
            //Los cobros facturados a mano no traen edificio, por eso van al final
            grupos.sort((a, b) => {
                if (a.edificio === this.SIN_EDIFICIO) { return 1; }
                if (b.edificio === this.SIN_EDIFICIO) { return -1; }
                return a.edificio.localeCompare(b.edificio);
            });
            for (const g of grupos) {
                g['totales'] = this.sumarColumnas(g.filas, columnas);
            }
            rep.gruposVisibles = grupos;

            // El edificio solo se muestra cuando la tarjeta mezcla varios: al filtrar por
            // un inmueble todos los renglones son del mismo y repetirlo seria ruido, pero
            // OP PREMIER es el operador y factura en varios edificios a la vez.
            const edificios = {};
            for (const c of rep.datosVisibles) {
                if (c && c.edificio) { edificios[c.edificio] = true; }
            }
            rep.edificiosMezclados = Object.keys(edificios).length > 1;
        }
    }

    /**
     * Deja en el selector de miembro solo los que aparecen en el inmueble elegido.
     *
     * NO se toca el miembro ya seleccionado: solo se acotan las opciones. Borrarselo al
     * cambiar de inmueble obligaria a capturar el filtro de nuevo, que es justo lo que se
     * corrigio en movimientos de obra.
     *
     * Tampoco se recalcula cuando ya hay un miembro elegido, porque en ese caso el
     * reporte viene filtrado a ese solo miembro y la lista se quedaria con una opcion,
     * sin manera de cambiarse a otra.
     */
    private acotarMiembros() {
        if (this.proveedor && this.proveedor.idProveedores) {
            return;
        }

        if (!this.obra || !this.obra.idObras) {
            this.proveedores = this.proveedoresTodos;
            return;
        }

        const presentes = {};
        for (const rep of (this.reporte || [])) {
            for (const c of ((rep && rep.datos) ? rep.datos : [])) {
                if (c && c.idProveedores) { presentes[c.idProveedores] = true; }
            }
        }

        const acotados = this.proveedoresTodos.filter((p) => presentes[p.idProveedores]);
        //Si por lo que sea no se pudo acotar, se deja la lista completa antes que dejar
        //al usuario con un selector vacio.
        this.proveedores = acotados.length > 0 ? acotados : this.proveedoresTodos;
    }

    public limpiarFiltros() {
        this.soloConAdeudo = false;
        this.soloVencidos = false;
        this.soloFacturadoMano = false;
        this.busqueda = '';
        this.aplicarFiltros();
    }

    public hayFiltrosActivos(): boolean {
        return this.soloConAdeudo || this.soloVencidos || this.soloFacturadoMano
            || (this.busqueda || '').trim() !== '';
    }

    public changeReporte(reporte) {
        if (reporte.id && reporte.id != this.reporte_actual.id) {
          this.router.navigate([reporte.ruta]);
        }
    }

    public return() {
        this.router.navigate(['/catalogo-reportes']);
    }

    public print() {
        setTimeout(() => {
          window.print();
        }, 1200);
    }

    public debugi(item){
        console.log('item: ',item);
    }

    //Abre el modal con el detalle de los cargos que componen la deuda del contrato
    public verDetalle(c, idObra?){
        //Los renglones facturados a mano no tienen contrato: su detalle se pide por cliente
        //e inmueble, que es como el reporte los junta.
        const esFacturadoDirecto = !!(c && c.facturado_directo && c.idProveedores && idObra);

        if(!c || (!c.id_contrato && !esFacturadoDirecto)){
            return;
        }

        this.detalle = null;
        this.loadingDetalle = true;
        this.detalleModalRef = this.modalService.open(this.detalleModal, { size: 'lg' as any, backdrop: 'static' });

        const peticion = esFacturadoDirecto
            ? this.reporteCobranzaService.getDetalleFacturadoDirecto(c.idProveedores, idObra, this.fechaTermino)
            : this.reporteCobranzaService.getDetalleCobranza(c.id_contrato, this.fechaTermino);

        peticion.subscribe(response => {
                this.detalle = response.json().content;
                this.loadingDetalle = false;
            }, error => {
                this.loadingDetalle = false;
                this.helperService.httpGlobalError(error);
            });
    }

    public cerrarDetalle(){
        if(this.detalleModalRef){
            this.detalleModalRef.close();
            this.detalleModalRef = null;
        }
        this.detalle = null;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/reporte-cobranza/reporte-cobranza.component.ts